import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-181b0ca3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "td-colon" }, ":", -1))

import { AttributeView } from "@/attribute/convert/AttributeView";
import { ISearchDateAttributeConvert } from "@/attribute/convert/ISearchDateAttributeConvert";
import {
  ScrollContent,
  ToggleContent,
  ButtonContainer,
  ButtonItem,
  InlineLink,
} from "@/components/modules";
import { FeatureType } from "@/geoMap/define/FeatureType";
import {
  withDefaults,
  Ref,
  ref,
  onMounted,
  watch,
} from "vue";

interface Props {
  searchDateAttributeConvert: ISearchDateAttributeConvert;
  mapTimeCode: string;
  fid?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'realtime-attribute',
  props: {
    searchDateAttributeConvert: {},
    mapTimeCode: {},
    fid: {}
  },
  emits: [
  "exportCsv",
  "exportJson",
  "clickRealtimeHistory",
  "moveMapToGeometry",
],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





/**
 * 表示データ
 */
const viewFormatData: Ref<AttributeView> = ref(null);

/**
 * 詳細開閉状態
 */
const isOpenToggle = ref(false);

/**
 * リアルタイム交通量過去データ表示可能時間
 */
const realtimeHistoryDisplayableTime: Ref<string> = ref(null);

/**
 * リアルタイム交通量過去データ表示対象地物タイプリスト（3時間）
 */
const REALTIME_HISTORY_3H_LIST = [
  FeatureType.TraVosCalc5MinRealTimeAttribute,
  FeatureType.TraVosCCDFiveMinRealTimeAttribute,
];

/**
 * リアルタイム交通量過去データ表示対象地物タイプリスト（12時間）
 */
const REALTIME_HISTORY_12H_LIST = [
  FeatureType.TraVosCalcHourRealTimeAttribute,
  FeatureType.TraVosCCDHourRealTimeAttribute,
];

/**
 * 表示データwatch
 */
watch(
  () => props.searchDateAttributeConvert,
  () => {
    refreshViewFormatData();
  }
);

/**
 * 表示内容更新
 */
const refreshViewFormatData = () => {
  viewFormatData.value = props.searchDateAttributeConvert.getViewFormatData();
};

/**
 * 詳細開閉状態更新
 */
const updateIsOpenToggle = (value: boolean) => {
  isOpenToggle.value = value;
};

/**
 * CSV出力
 */
const exportCsv = () => {
  emit("exportCsv", props.searchDateAttributeConvert);
};

/**
 * JSON出力
 */
const exportJson = () => {
  emit("exportJson", props.searchDateAttributeConvert);
};

/**
 * 地図を地物の位置へ移動
 */
const moveMapToGeometry = () => {
  const geometry = props.searchDateAttributeConvert
    .getExportValue()
    .feature.getGeometry();
  emit("moveMapToGeometry", geometry);
};

/**
 * リアルタイム過去時系列データをクリック
 */
const clickRealtimeHistory = () => {
  emit("clickRealtimeHistory", props.fid, props.searchDateAttributeConvert);
};

/**
 * 初期処理
 */
onMounted(() => {
  refreshViewFormatData();
  if (
    REALTIME_HISTORY_3H_LIST.indexOf(
      props.searchDateAttributeConvert?.getFeatureType()
    ) >= 0
  ) {
    realtimeHistoryDisplayableTime.value = "3";
  } else if (
    REALTIME_HISTORY_12H_LIST.indexOf(
      props.searchDateAttributeConvert?.getFeatureType()
    ) >= 0
  ) {
    realtimeHistoryDisplayableTime.value = "12";
  }
});

__expose({ refreshViewFormatData });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ScrollContent), {
    height: 
      viewFormatData.value?.height && !isOpenToggle.value
        ? viewFormatData.value.height + 'px'
        : viewFormatData.value?.maxheight && isOpenToggle.value
        ? viewFormatData.value.maxheight + 'px'
        : '500px'
    
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(InlineLink), { onClick: moveMapToGeometry }, {
        default: _withCtx(() => [
          _createTextVNode("地物に移動")
        ]),
        _: 1
      }),
      (realtimeHistoryDisplayableTime.value)
        ? (_openBlock(), _createBlock(_unref(InlineLink), {
            key: 0,
            class: "realtime-history-button",
            onClick: clickRealtimeHistory
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 過去" + _toDisplayString(realtimeHistoryDisplayableTime.value) + "時間の時系列データ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewFormatData.value?.attributeValues.length, (index) => {
        return (_openBlock(), _createElementBlock("table", {
          key: viewFormatData.value.attributeValues[index - 1].key
        }, [
          (
          isOpenToggle.value || viewFormatData.value.attributeValues[index - 1].isSimple
        )
            ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                _createElementVNode("td", null, _toDisplayString(viewFormatData.value.attributeValues[index - 1].key), 1),
                _hoisted_2,
                _createElementVNode("td", null, _toDisplayString(viewFormatData.value.attributeValues[index - 1].value !== null &&
            viewFormatData.value.attributeValues[index - 1].value !== undefined &&
            String(viewFormatData.value.attributeValues[index - 1].value).replaceAll(
              " ",
              ""
            ) !== ""
              ? String(viewFormatData.value.attributeValues[index - 1].value)
              : "-"), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (
        (isOpenToggle.value ||
          (viewFormatData.value?.attributeValues &&
            !viewFormatData.value.attributeValues.some((ele) => {
              return !ele.isSimple;
            }))) &&
        (!viewFormatData.value?.csvOutputUnPossibility ||
          !viewFormatData.value?.jsonOutputUnPossibility)
      )
        ? (_openBlock(), _createBlock(_unref(ButtonContainer), {
            key: 1,
            align: "left"
          }, {
            default: _withCtx(() => [
              (!viewFormatData.value.csvOutputUnPossibility)
                ? (_openBlock(), _createBlock(_unref(ButtonItem), {
                    key: 0,
                    onClick: exportCsv
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("CSV出力")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!viewFormatData.value.jsonOutputUnPossibility)
                ? (_openBlock(), _createBlock(_unref(ButtonItem), {
                    key: 1,
                    onClick: exportJson
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("GeoJSON出力")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        viewFormatData.value?.attributeValues?.some((ele) => {
          return !ele.isSimple;
        })
      )
        ? (_openBlock(), _createBlock(_unref(ToggleContent), {
            key: 2,
            text: { open: '詳細表示', close: '詳細非表示' },
            onToggle: updateIsOpenToggle
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["height"]))
}
}

})